"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSymbol = void 0;
/** Validator that only allows symbols. */

var isSymbol = function isSymbol(value) {
  if (_typeof(value) !== 'symbol') {
    return 'value should be a symbol';
  }

  return undefined;
};

exports.isSymbol = isSymbol;